import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '../style/colors';
import Reward from '../lib/reward';
import { t } from '../lib/i18n';

function RewardDetails(props) {
    const reward = props.reward;

    const badgeClassName = `badge ${reward.statusColor()}`;
    return (<dl className={`reward-details ${props.className}`}>
        <header>
            <span className="campaign-name">{reward.campaignName}</span>
            <span className={badgeClassName}>{reward.statusName()}</span>
            {(() => {
                if (reward.userHasContactedSupport && reward.status === 'PENDING') {
                    return (<span className="badge user-has-contacted-support">
                        {t('statusOverview.userHasContactedSupportText')}
                    </span>);
                }
                return null;
            })()}
        </header>

        <dt>{t('rewardFieldNames.value')}</dt>
        <dd>{reward && reward.valueDescription()}</dd>

        {(() => {
            if (!reward || !reward.durationFromNow()) {
                return null;
            }
            return (<span>
                <dt>{t('rewardFieldNames.eventTimestamp')}</dt>
                <dd>{reward.durationFromNow()}</dd>

                <dt>{t('rewardFieldNames.averageDuration')}</dt>
                <dd>{reward.averageDurationString()}</dd>
            </span>);
        })()}

        {(() => {
            if (!reward || !reward.reason || reward.reason === 'UNKNOWN') {
                return null;
            }
            return (<span>
                <dt>{t('rewardFieldNames.reason')}</dt>
                <dd>{reward.reason}</dd>
            </span>);
        })()}

    </dl>);
}

RewardDetails.propTypes = PropTypes.shape(Reward.propTypes);

const StyledRewardDetails = styled(RewardDetails)`
    display: inline-block;
    width: 100%;
    header .badge {
        float: right;
        &.user-has-contacted-support {
            background-color: #ada8a0;
        }
    }
    .campaign-name {
        float: left;
        font-weight: bolder;
    }

    dt, dd {
        max-width: 66%;
    }

    dt {
        float: left;
        clear: both;
        margin-right: 1em;
    }

    dd {
        float: right;
        text-align: right;
    }

    .badge {
        display: inline-block;
        margin: 0;
        padding: 0.18em 0.5em 0.1em;
        min-width: 1em;
        font-size: 75%;
        font-weigt: bold;
        line-height: 1.3333;
        text-align: center;
        color: white;
        border-radius: 1em;
        text-shadow: 0 -0.04em 0em rgba(0, 0, 0, 0.2);
        &.positive {
            background-color: ${colors.green};
            color: black;
        }
        &.neutral {
            background-color: ${colors.yellow};
        }
        &.negative {
            background-color: ${colors.red};
        }
    }

    * + .badge {
        margin-left: 0.5em;
    }
`;

export default StyledRewardDetails;


// WEBPACK FOOTER //
// ./src/components/reward-details.jsx